module.exports = __webpack_public_path__ + "static/media/second-banner.ea53b027.png";